import React from "react";
import { Button, SxProps } from "@mui/material";

interface ByzMuiDtButtonProps extends React.ComponentProps<typeof Button> {
  variant?: "text" | "outlined" | "contained";
  color?:
    | "primary"
    | "secondary"
    | "error"
    | "inherit"
    | "warning"
    | "info"
    | "success";
  onClick: () => void;
  children: React.ReactNode;
  sx? : SxProps;
}

const ByzMuiDtButton: React.FC<ByzMuiDtButtonProps> = ({
  variant = "contained",
  color = "primary",
  onClick,
  children,
  sx
}) => {
  return (
    <Button sx={sx} variant={variant} color={color} onClick={onClick}>
      {children}
    </Button>
  );
};

export default ByzMuiDtButton;
